var React = require('react');

function QK1i (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#246648","d":"M78.535 171.918h80v40h-80z","key":0}),React.createElement("path",{"fill":"#C49675","d":"M119 122.544c-22.091 0-40-17.909-40-40H39c0 44.183 35.818 80 80 80 44.183 0 80-35.817 80-80h-40c0 22.091-17.909 40-40 40z","key":1}),React.createElement("path",{"fill":"#648029","d":"M90.716 54.224L62.432 25.94c31.242-31.242 81.895-31.242 113.137 0l-28.284 28.284c-15.622-15.621-40.948-15.621-56.569 0z","key":2}),React.createElement("path",{"fill":"#4C372E","d":"M.005 40.082c0 22.091 17.909 40 40 40v-80c-22.091 0-40 17.908-40 40z","key":3}),React.createElement("path",{"fill":"#E9CBAF","d":"M237.995 40.082c0-22.091-17.909-40-40-40v80c22.091 0 40-17.909 40-40z","key":4})]);
}

QK1i.defaultProps = {"viewBox":"0 0 238 212"};

module.exports = QK1i;

QK1i.default = QK1i;
